import type { TOC } from '@ember/component/template-only';
import LoanVerificationPage from 'tio-employee/components/slr/loan-verification';
import type AuthenticatedSlrLoanVerificationController from 'tio-employee/controllers/authenticated/slr/loan-verification';
import type { AuthenticatedSlrLoanVerificationModel } from 'tio-employee/routes/authenticated/slr/loan-verification';

interface LoanVerificationRouteSignature {
  Args: {
    /** Carries the `:resolution_id` segment the page loads. */
    model: AuthenticatedSlrLoanVerificationModel;
    /** Holds the `from` query param that picks where the back link returns. */
    controller: AuthenticatedSlrLoanVerificationController;
  };
}

const LoanVerificationRouteComponent: TOC<LoanVerificationRouteSignature> = <template>
  <LoanVerificationPage @resolutionId={{@model.resolutionId}} @from={{@controller.from}} />
</template>;

export default LoanVerificationRouteComponent;
